// sensei-app/client/ui/ClassroomToolbar.js
import { ComponentBase } from "../../core/ComponentBase.js";

export class ClassroomToolbar extends ComponentBase {
    static styles = `
        .classroom-toolbar {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0.5rem 1rem;
            background-color: var(--bs-tertiary-bg);
            border-bottom: 1px solid var(--bs-border-color);
            flex-shrink: 0;
        }
        .timer-container {
            font-family: monospace;
            font-weight: 500;
            font-size: 1.1rem;
            color: var(--bs-emphasis-color);
        }
        .toolbar-actions .btn {
            font-size: 1.25rem; /* Larger icons */
            padding: 0.25rem 0.5rem;
        }
    `;

    constructor(config) {
        super(config);
        this.startTime = this.config.startTime || null;
        this.timerInterval = null;
        this.applyStyles();
    }

    onShow() { this.startTimer(); }

    startTimer() {
        if (this.timerInterval) clearInterval(this.timerInterval);
        if (!this.startTime || !this.container) return;

        const timerElement = this.container.querySelector('.timer');
        if (!timerElement) return;

        this.timerInterval = setInterval(() => {
            const elapsedMs = new Date() - this.startTime;
            const totalSeconds = Math.floor(elapsedMs / 1000);
            const minutes = Math.floor(totalSeconds / 60).toString().padStart(2, '0');
            const seconds = (totalSeconds % 60).toString().padStart(2, '0');
            timerElement.textContent = `${minutes}:${seconds}`;
        }, 1000);
    }

    render() {
        if (!this.container) {
            this.container = document.createElement('div');
            this.container.className = 'classroom-toolbar';
            this.container.innerHTML = `
            <div class="timer-container">
                <i class="bi bi-stopwatch-fill me-2 text-primary"></i><span class="timer">00:00</span>
            </div>
            <div class="toolbar-actions btn-group">
                <button id="raise-hand-btn" class="btn btn-link text-secondary" title="${this.t('Raise Hand')}">
                    <i class="bi bi-hand-index-thumb-fill"></i>
                </button>
                <!-- NEW: Pause Button -->
                <button id="pause-class-btn" class="btn btn-link text-secondary" title="${this.t('Pause Session')}">
                    <i class="bi bi-pause-circle-fill"></i>
                </button>
                <button id="end-class-btn" class="btn btn-link text-danger" title="${this.t('End Class')}">
                    <i class="bi bi-box-arrow-right"></i>
                </button>
            </div>
        `;

            this.container.querySelector('#raise-hand-btn').addEventListener('click', () => this.emit('raiseHandClicked'));
            this.container.querySelector('#pause-class-btn').addEventListener('click', () => this.emit('pauseClassClicked')); // NEW
            this.container.querySelector('#end-class-btn').addEventListener('click', () => this.emit('endClassClicked'));
        }
        this.startTimer();
        this.appClient.tx.applyTranslations(this.container);
        return this.container;
    }


    destroy() {
        if (this.timerInterval) clearInterval(this.timerInterval);
        super.destroy();
    }
}